/******Brij JS */
var materials = ['wgold','ygold','rgold'];
var materialsTypeNames = {"platinum": "Platinum","wgold":"White Gold", "ygold":"Yellow Gold","rgold":"Rose Gold"};
var settingTypes = [{"id":"1","name":"Diamond Band"},{"id":"2","name":"Halo"},{"id":"3","name":"Solitaire"},{"id":"4","name":"Three Stone"}];
var settings = [{"id":"29","dyrSettingTypeId":"3","ref":"ER12033-3MM"},{"id":"30","dyrSettingTypeId":"3","ref":"LM785-65W8"},{"id":"31","dyrSettingTypeId":"3","ref":"4300-6P-250BR"},{"id":"32","dyrSettingTypeId":"3","ref":"4300-6P-125BR"},{"id":"33","dyrcurrentDcrSettingTypeId":"3","ref":"4300-6P-100BR"},{"id":"34","dyrSettingTypeId":"2","ref":"ER12033H_31-6P-3MM"},{"id":"35","dyrSettingTypeId":"4","ref":"1KRNBLT_62-625P"},{"id":"36","dyrSettingTypeId":"4","ref":"442_20-625P"},{"id":"37","dyrSettingTypeId":"4","ref":"470_56-7P"},{"id":"38","dyrSettingTypeId":"4","ref":"560_54-675P"},{"id":"40","dyrSettingTypeId":"1","ref":"2DP2_48-65P"},{"id":"41","dyrSettingTypeId":"1","ref":"10RB26_38-6W8"},{"id":"42","dyrSettingTypeId":"1","ref":"288_36-65P"},{"id":"43","dyrSettingTypeId":"1","ref":"3DN209RTT_104-6W8"},{"id":"44","dyrSettingTypeId":"1","ref":"435_50-55W8"},{"id":"45","dyrSettingTypeId":"1","ref":"435_61-675W8"},{"id":"46","dyrSettingTypeId":"1","ref":"497_121"},{"id":"47","dyrSettingTypeId":"1","ref":"565_40-65P"},{"id":"48","dyrSettingTypeId":"1","ref":"630_59"},{"id":"49","dyrSettingTypeId":"1","ref":"732_67-65P"},{"id":"50","dyrSettingTypeId":"1","ref":"720819_10-6P"},{"id":"51","dyrSettingTypeId":"1","ref":"BMBPAL12_29-65W8"},{"id":"52","dyrSettingTypeId":"3","ref":"4300-6P-150BR"},{"id":"53","dyrSettingTypeId":"3","ref":"4300-6P-200BR"},{"id":"54","dyrSettingTypeId":"3","ref":"4300-625P-75BR"},{"id":"55","dyrSettingTypeId":"3","ref":"4300-5P-100BR"},{"id":"56","dyrSettingTypeId":"3","ref":"43"},{"id":"57","dyrSettingTypeId":"3","ref":"R450"},{"id":"58","dyrSettingTypeId":"1","ref":"L5693_46-675P"},{"id":"59","dyrSettingTypeId":"1","ref":"Z1FCT97SD_25-65W8"},{"id":"60","dyrSettingTypeId":"1","ref":"SQ_226-65P"},{"id":"62","dyrSettingTypeId":"1","ref":"ZRRVTRP21_32-65W8"},{"id":"64","dyrSettingTypeId":"1","ref":"L6530PTE_40-65P"},{"id":"66","dyrSettingTypeId":"1","ref":"MJST10_31-65P"},{"id":"67","dyrSettingTypeId":"1","ref":"Z111.33.12NE_24BL.10"},{"id":"68","dyrSettingTypeId":"1","ref":"N209_72-65P"},{"id":"69","dyrSettingTypeId":"1","ref":"MRR54SEJ_89-65P"},{"id":"70","dyrSettingTypeId":"1","ref":"2MJST-20_18BL_51"},{"id":"71","dyrSettingTypeId":"1","ref":"2PALL2P_40BL_63"},{"id":"72","dyrSettingTypeId":"2","ref":"MR232_57-7P"},{"id":"73","dyrSettingTypeId":"2","ref":"R36391_37"},{"id":"74","dyrSettingTypeId":"4","ref":"R238110-65P_25"},{"id":"75","dyrSettingTypeId":"1","ref":"356BG2LZ_73"},{"id":"76","dyrSettingTypeId":"1","ref":"2111.46.12.2_49BL_65"},{"id":"78","dyrSettingTypeId":"1","ref":"ZRJOYPA_32BL_44-65W8"},{"id":"79","dyrSettingTypeId":"1","ref":"NO2_55-65W8"},{"id":"80","dyrSettingTypeId":"4","ref":"TR102NS_41_52"},{"id":"81","dyrSettingTypeId":"4","ref":"TR102NS_52_72"},{"id":"82","dyrSettingTypeId":"1","ref":"SR01797_54-65P"},{"id":"83","dyrSettingTypeId":"1","ref":"SR1909_26-65P"},{"id":"84","dyrSettingTypeId":"2","ref":"RRARDBZ_81-65P"},{"id":"85","dyrSettingTypeId":"2","ref":"1COR24WD_49"},{"id":"86","dyrSettingTypeId":"1","ref":"P214M4_26-575W8"},{"id":"87","dyrSettingTypeId":"1","ref":"SR_69"},{"id":"88","dyrSettingTypeId":"1","ref":"SR01859_50-625P"},{"id":"89","dyrSettingTypeId":"1","ref":"SR02128-65P"},{"id":"1","dyrSettingTypeId":"1","ref":"1UNT34Z_28BL_55-65P"},{"id":"13","dyrSettingTypeId":"2","ref":"1ROFFOSR_24-65W8"},{"id":"17","dyrSettingTypeId":"3","ref":"Z1SPDMHELF-65W8"},{"id":"18","dyrSettingTypeId":"4","ref":"1KRN76_29-65P"},{"id":"2","dyrSettingTypeId":"1","ref":"300_65-675P"},{"id":"14","dyrSettingTypeId":"2","ref":"665_70"},{"id":"19","dyrSettingTypeId":"4","ref":"1KRNBLT_50B_55"},{"id":"26","dyrSettingTypeId":"3","ref":"ER12033-3.5MM"},{"id":"4","dyrSettingTypeId":"1","ref":"F20B_89-65W8"},{"id":"15","dyrSettingTypeId":"2","ref":"RRFLSGL_50B_119-65P"},{"id":"20","dyrSettingTypeId":"4","ref":"500_24-475P"},{"id":"3","dyrSettingTypeId":"1","ref":"F20_168-65P"},{"id":"16","dyrSettingTypeId":"2","ref":"ZRJOYEQX_48-65W8"},{"id":"21","dyrSettingTypeId":"4","ref":"855_26-65P"},{"id":"5","dyrSettingTypeId":"1","ref":"L3979_30-625P"},{"id":"22","dyrSettingTypeId":"4","ref":"885_78-625P"},{"id":"6","dyrSettingTypeId":"1","ref":"MR27SE16_76-675W8"},{"id":"23","dyrSettingTypeId":"4","ref":"B1955_27-65W8"},{"id":"7","dyrSettingTypeId":"1","ref":"MRSEA54_83-55W8"},{"id":"24","dyrSettingTypeId":"4","ref":"L5239E_20B_29-65P"},{"id":"8","dyrSettingTypeId":"1","ref":"NO2_ENG_44-65P"},{"id":"25","dyrSettingTypeId":"4","ref":"R238011-625P_60"},{"id":"9","dyrSettingTypeId":"1","ref":"SFP2M4_48-575W8"},{"id":"10","dyrSettingTypeId":"1","ref":"ZGRACE3_139-675W8"},{"id":"11","dyrSettingTypeId":"1","ref":"ZRPVINF_58-65W8"},{"id":"12","dyrSettingTypeId":"1","ref":"ZTLP2RT_73BL_123-W8"}];

var currentMaterial, currentMaterialName, currentDcri = '_050', currentMaterialKType = 'platinum', currentSettingType = settingTypes[0].id, currentDiamondType = 'round', currentDiamondTType = 'NATURAL', currentRingIndex = 0, settingTypeCounts = {}, currentSettings, currentDcr = 0.50, currentDcol = 'COLORLESS D-F', currentDcut = 'GOOD', currentDcla = 'VVSI-VVS2';
$.noConflict();
jQuery( document ).ready(function( $ ) {
  
  $(document).on("click",".changeMaterialK",function() {
    var materialK = $(this).attr("data-mkvalue");
    if(materialK == "platinum"){
       changeMaterial("platinum");
      $(".material").hide();
    }else{
      changeMaterial("wgold");
      $(".material").show();
    }
    changeMaterialK(materialK);
  });
  function changeMaterialK(materialK) {
  	currentMaterialKType = materialK;
  	$( ".materialK li" ).each(function() {
          $(this).removeClass( "active" );
          if( $(this).data('mkvalue') == materialK ){
              // diamondHtml = $(this).html();
              $(this).addClass( "active" );
          }
      });
  	// $('div.mm-dropdown.diamond-main .textfirst').html(diamondHtml);
  	removeactive();
  	updateRings();
  }
  $(document).on("click",".changeMaterial",function() {
    var material = $(this).attr("data-mvalue");
    changeMaterial(material);
  });
  function changeMaterial(material, initLoad = false) {
      currentMaterial = (material == 'platinum' ) ? 'wgold' : material;
  	  currentMaterialName = material;
      var materialHtml = 'Select Metal';
      $( ".matel-main .material li" ).each(function() {
          $(this).removeClass( "active" );
          if( $(this).data('mvalue') == material ){
              materialHtml = $(this).html();
              $(this).addClass( "active" );
          }
      });
      // $('div.matel-main .textfirst').html(materialHtml);
      var html = '';
      for(var i = 0; i < settingTypes.length; i++) {
  		var activeClass = '';
  		if (settingTypes[i].id == currentSettingType) {
  			activeClass = 'active';
  			// $('div.style-main .textfirst').html('<div class="settingOption" style="background-image: url('+config.custom_ringdata.ASSETPATH+'/settingTypes/'+currentSettingType+'-'+currentMaterial+'.jpg);"></div><div class="settingName">'+settingTypes[i].name+'</div>');
  		}
          html += '<li class="input-option changeSetting '+ activeClass +'" data-svalue="'+settingTypes[i].id+'" ><div class="settingOption" style="background-image: url('+config.custom_ringdata.ASSETPATH+'/settingTypes/'+settingTypes[i].id+'-'+currentMaterial+'.jpg);"></div><div class="settingName">'+settingTypes[i].name+'</div></li>';
      }
      removeactive();
      $('#ringSettingTypes').html(html);
      updateRings(initLoad);
  }
  
  $(document).on("click",".changeSetting",function() {
    var settingType = $(this).attr("data-svalue");
    changeSetting(settingType);
  });
  function changeSetting(settingType) {
  	currentSettingType = settingType;
  	currentSettings = [];
  	var styleHtml = '';
  	$( ".style-main li" ).each(function() {
          $(this).removeClass( "active" );
          if( $(this).data('svalue') == settingType ){
              styleHtml = $(this).html();
              $(this).addClass( "active" );
          }
      });
  	// $('div.style-main .textfirst').html(styleHtml);
  	for(var i = 0; i < settings.length; i++) {
  		if(settings[i].dyrSettingTypeId == currentSettingType) {
  			currentSettings.push(settings[i]);
  		}
  	}
  	updateRings();
  	removeactive();
  	if($(window).width() < 1352) {
  		$('.slider-for').css('transform', 'translateX(0px)');
  	} else {
  		//$('.slider-for').css('transform', 'translateX(402px)');
  	}
  	currentRingIndex = 0;
  	//setButtonActions();
  	//updateRef();
  }
  $(document).on("click",".changeDiamondT",function() {
    var diamondT = $(this).attr("data-mdvalue");
    changeDiamondT(diamondT);
  });
  function changeDiamondT(diamondT) {
  	currentDiamondTType = diamondT;
  	$( ".diamondT li" ).each(function() {
          $(this).removeClass( "active" );
          if( $(this).data('mdvalue') == diamondT ){
              // diamondHtml = $(this).html();
              $(this).addClass( "active" );
          }
      });
  	// $('div.mm-dropdown.diamond-main .textfirst').html(diamondHtml);
  	removeactive();
  	updateRings();
  }
  
  $(document).on("click",".changeDiamond",function() {
    var diamondType = $(this).attr("data-dvalue");
    changeDiamond(diamondType);
  });
  function changeDiamond(diamondType) {
  	currentDiamondType = diamondType;
  	$( ".diamond-main .diamond li" ).each(function() {
          $(this).removeClass( "active" );
          if( $(this).data('dvalue') == diamondType ){
              // diamondHtml = $(this).html();
              $(this).addClass( "active" );
          }
      });
  	// $('div.mm-dropdown.diamond-main .textfirst').html(diamondHtml);
  	removeactive();
  	updateRings();
  }
  $(document).on("click",".changeDcr",function() {
    var dcr = $(this).attr("data-dcr");
    var dcri = $(this).attr("data-dcri");
    changeDcr(dcr, dcri);
  });
  function changeDcr(dcr, dcri) {
  	currentDcr = dcr;
    currentDcri = dcri;
  	$( ".diamondcar-main ul li" ).each(function() {
          $(this).removeClass( "active" );
          if( $(this).data('dcr') == dcr ){
              // diamondHtml = $(this).html();
              $(this).addClass( "active" );
          }
      });
  	// $('div.mm-dropdown.diamond-main .textfirst').html(diamondHtml);
  	removeactive();
  	updateRings();
  }
  $(document).on("click",".changeDcol",function() {
    var dcol = $(this).attr("data-dcol");
    changeDcol(dcol);
  });
  function changeDcol(dcol) {
  	currentDcol = dcol;
  	$( ".diamondcol-main ul li" ).each(function() {
          $(this).removeClass( "active" );
          if( $(this).data('dcol') == dcol ){
              // diamondHtml = $(this).html();
              $(this).addClass( "active" );
          }
      });
  	// $('div.mm-dropdown.diamond-main .textfirst').html(diamondHtml);
  	removeactive();
  	updateRings();
  }

  $(document).on("click",".changeDcut",function() {
    var dcut = $(this).attr("data-dcut");
    changeDcut(dcut);
  });
  function changeDcut(dcut) {
  	currentDcut = dcut;
  	$( ".diamondcut-main ul li" ).each(function() {
          $(this).removeClass( "active" );
          if( $(this).data('dcut') == dcut ){
              // diamondHtml = $(this).html();
              $(this).addClass( "active" );
          }
      });
  	// $('div.mm-dropdown.diamond-main .textfirst').html(diamondHtml);
  	removeactive();
  	updateRings();
  }
  
  $(document).on("click",".changeDcla",function() {
    var dcla = $(this).attr("data-dcla");
    changeDcla(dcla);
  });
  function changeDcla(dcla) {
  	currentDcla = dcla;
  	$( ".diamondclarity-main ul li" ).each(function() {
          $(this).removeClass( "active" );
          if( $(this).data('dcla') == dcla ){
              // diamondHtml = $(this).html();
              $(this).addClass( "active" );
          }
      });
  	// $('div.mm-dropdown.diamond-main .textfirst').html(diamondHtml);
  	removeactive();
  	updateRings();
  }
  
 
 
  function updateRings(initLoad = false) {
  	if(!initLoad){
  		destroySlider('.slider-for');
  	}
  	var html = '';
  	var html1 = '';
  	var settingCount = 1;
     var CMT = "";
    if(currentMaterialKType == "ANY"){
      currentMaterialKType = "";
    }else{
      currentMaterialKType = currentMaterialKType;
    }
    if(currentDiamondTType == "EITHER"){
      currentDiamondTType = "";
    }else{
      currentDiamondTType = currentDiamondTType;
    }
    if(currentMaterialKType != "platinum"){
      var CMT = currentMaterialKType;
    }
  	for(var i = 0; i < settings.length; i++) {
  		if(settings[i].dyrSettingTypeId == currentSettingType) {
              // Ref#, Matel, Style, Diamond
  			html += '<div class="slider-box" >';
              html += '<div class="data-set" data-ringid="'+settings[i].id+'" data-ringref="'+settings[i].ref+'#!#'+ materialsTypeNames[currentMaterialName] +'#!#'+ settingTypes[currentSettingType-1].name +'#!#'+ ucFirst(currentDiamondType) +'" data-ringImage="'+config.custom_ringdata.ASSETPATH+'/settings/'+settings[i].id+'-'+currentMaterial+'.jpg" data-ringInfo="'+CMT+' '+materialsTypeNames[currentMaterialName]+' '+settingTypes[currentSettingType-1].name+' ENGAGEMENT RING W/ '+currentDcr+' CTW '+currentDiamondType+' '+currentDiamondTType+' Diamond." data-dimandImage="'+config.custom_ringdata.ASSETPATH+'/diamonds/'+ currentDiamondType+currentDcri+'.png" data-materialK="'+currentMaterialKType+'" data-diamondT="'+currentDiamondTType+'" data-dcr="'+currentDcr+'" data-dcol="'+currentDcol+'" data-dcut="'+currentDcut+'" data-dcla="'+currentDcla+'">'
  				html += '<div class="imageWrapper" style="background-image: url('+config.custom_ringdata.ASSETPATH+'/settings/'+settings[i].id+'-'+currentMaterial+'.jpg);">';
  					html += '<img alt="'+CMT+' '+materialsTypeNames[currentMaterialName]+' '+settingTypes[currentSettingType-1].name+' ENGAGEMENT RING W/ '+currentDcr+' CTW '+currentDiamondType+' '+currentDiamondTType+' Diamond." class="diamond" src="'+config.custom_ringdata.ASSETPATH+'/diamonds/'+currentDiamondType+currentDcri+'.png"/>';
  					html += '<div style="display:none" class="ref">REF #'+settings[i].ref+' <span class="ringCount">- '+(settingCount)+'/'+(settingTypeCounts[currentSettingType])+'</span></div>';
  				html += '</div>';
              html += '</div>';
  			html += '</div>';
  
  			html1 += '<div class="slider-box"><div class="ref">REF #'+settings[i].ref+' <span class="ringCount">- '+(settingCount)+'/'+(settingTypeCounts[currentSettingType])+'</span></div></div>';
  			settingCount++;
  		}
  	}
    
    $(".ringPreview h2").text(CMT+" "+materialsTypeNames[currentMaterialName]+" "+settingTypes[currentSettingType-1].name+" ENGAGEMENT RING W/ "+currentDcr+" CTW "+currentDiamondType+" "+currentDiamondTType+" Diamond.")
  	$('.slider-for').html(html);
  	initSlider();
  	$('.slider-nav').html(html);
  	initSliderNav();
  	updateRef();
  }
  
  function ucFirst(string) {
  	return string.charAt(0).toUpperCase() + string.slice(1);
  }
  
  function removeactive(){
      $( ".mm-dropdown" ).each(function() {
          $(this).find('ul').removeClass( "active" );
      });
  }
  
  function updateRef() {
  	$('#ringInfo').html('REF: '+currentSettings[currentRingIndex].ref+' <span class="ringCount">- '+(currentRingIndex+1)+'/'+(settingTypeCounts[currentSettingType])+'</span>');
  }
  /******Old JS */
  function destroySlider(sliderClass){
  	$(sliderClass).slick('unslick');
  }
  function initSlider() {
  	$('.slider-for').slick({
  		infinite: true,
  		slidesToShow: 1,
  		slidesToScroll: 1,
  		arrows: true,
  		focusOnSelect: true,
  		centerMode: true,
  		responsive: [{
  			breakpoint: 600,
  			settings: {
                focusOnSelect: true,
        		centerMode: false,
                arrows: true,
  				slidesToShow: 1,
  				slidesToScroll: 1
  			}
  		},
  		{
  			breakpoint: 400,
  			settings: {
                focusOnSelect: true,
        		centerMode: false,
  				arrows: true,
  				slidesToShow: 1,
  				slidesToScroll: 1
  			}
  		}]
  	});
  }
  function initSliderNav(){
  	$('.slider-nav').slick({
  		slidesToShow: 1,
  		slidesToScroll: 1,
  		arrows: false,
  		dots: false,
  		asNavFor: '.slider-for',
  		centerMode: true
  	});
  }
  $('.info_field input').keypress(function() {
    $(this).removeClass('ferror');
    $('.info_field textarea').removeClass('ferror');
  });
  $('.form-group input').keypress(function() {
    $(this).removeClass('ferror');
  });
  
  $(document).on("click",".printRing",function() {
    printRing();
  });
  
  function printRing() {
      var printWin = window.open('', '_blank');
      printWin.document.write('<link rel="stylesheet" type="text/css" href="'+config.custom_ringdata.ASSETPATH+'/css/print.css"/><div id="viewlarge"><div class="modal-body">');
      printWin.document.write($('.popup-print .popup-data').html());
      printWin.document.write('</div></div>');
      printWin.document.close();
      var fullImageBox = $(printWin.document).find('.crd_popup_ring_src');
      fullImageBox.append('<img src="'+getBGUrl(fullImageBox)+'"/>');
      fullImageBox.css('background-image', 'none');
      var diamond = $(printWin.document).find('.crd_popup_diamond_src');
      fullImageBox.append('<div class="diamond"><img src="'+diamond.attr('src')+'"/></div>');
      diamond.remove();
      printWin.focus();
      setTimeout(function() {
          printWin.print();
          printWin.close();
      }, 500);
  }
  $(document).on("click",".submitshare",function() {
    submitshare();
    $(this).addClass('disable');
  });
  function submitshare(){
     
      var submitFormElement = document.getElementById('ring_share_form');
      let submitFormData = new FormData(submitFormElement);
      var formElement = document.getElementById('info_form');
      let formData = new FormData(formElement);
      var submitPath = config.custom_ringdata.BASEPATH;
      let sendRequest = new XMLHttpRequest();
      sendRequest.open("POST", submitPath + 'formrender/fetch', true);
      sendRequest.onreadystatechange = function () {
          var close_pop = 0;
          if(this.readyState === 4 && this.status === 200){
              var resultAfterFormSubmit = JSON.parse(this.response);
              if(resultAfterFormSubmit.html == 'EmailSent'){
                  document.querySelector('.share_form_btn .formsuccess_msg').innerHTML= '<span style="">Thank you! We have shared your request.</span>';
                  submitFormElement.reset();
                  $('.form-group input').removeClass('ferror');
                  $(".popup-form #s_name").html('');
                  $(".popup-form #s_email").html('');
                  $(".popup-form #comments").html('');
                  formElement.reset();
                 
              }else if(resultAfterFormSubmit.html == 'empty'){
                  const error_obj = resultAfterFormSubmit.error;
                  for (const key in error_obj) {
                    $("input[name='"+key+"']").addClass('ferror');
                    if (key == "fname") {
                      close_pop = 1;
                    }
                    if (key == "comments") {
                      $("textarea[name='"+key+"']").addClass('ferror');
                    }
                  }
                  document.querySelector('.share_form_btn .formsuccess_msg').innerHTML= '<span style="color:red">Please fill the required fields!</span>';
                 
              }
          }
          if(close_pop == 1){
            $(".close-btn").text('Back');
            $(".close-btn").addClass('error_close');
          }else{
            $(".close-btn").text('Close');
            $(".close-btn").removeClass('error_close');
          }
          $(".submitshare").removeClass('disable');
      }
      sendRequest.send(submitFormData);
  }
  $(document).on("click",".submitquote",function() {
    submitquote();
    $(this).addClass('disable');
  });
  function submitquote(){
      
      var submitFormElement = document.getElementById('ring_quote_form');
      let submitFormData = new FormData(submitFormElement);
      var formElement = document.getElementById('info_form');
      let formData = new FormData(formElement);
      var submitPath = config.custom_ringdata.BASEPATH;
      let sendRequest = new XMLHttpRequest();
      sendRequest.open("POST", submitPath + 'formrender/fetch', true);
      sendRequest.onreadystatechange = function () {
         var close_pop = 0;
          if(this.readyState === 4 && this.status === 200){
              var resultAfterFormSubmit = JSON.parse(this.response);
              if(resultAfterFormSubmit.html == 'EmailSent'){
                  document.querySelector('.quote_form_btn .formsuccess_msg').innerHTML= '<span style="">Thank you! Our team will contact you.</span>';
                  submitFormElement.reset();
                  $('.info_field input').removeClass('ferror');
                  $('.info_field textarea').removeClass('ferror');
                  formElement.reset();
                
              }else if(resultAfterFormSubmit.html == 'empty'){
                console.log(JSON.stringify(resultAfterFormSubmit.error));
                const error_obj = resultAfterFormSubmit.error;
                  for (const key in error_obj) {
                    $("input[name='"+key+"']").addClass('ferror');
                    if (key == "fname" || key == "email" || key == "phone" || key == "address" || key == "state" || key == "zip" || key == "comments") {
                      close_pop = 1;
                    }
                    if (key == "comments") {
                      $("textarea[name='"+key+"']").addClass('ferror');
                    }
                  }
                  document.querySelector('.quote_form_btn .formsuccess_msg').innerHTML= '<span style="color:red">Please fill the required fields!</span>';
                 
              }
          }
          if(close_pop == 1){
            $(".close-btn").text('Back');
            $(".close-btn").addClass('error_close');
          }else{
            $(".close-btn").text('Close');
            $(".close-btn").removeClass('error_close');
          }
          $(".submitquote").removeClass('disable');
      }
      sendRequest.send(submitFormData);
  }
  
  function getBGUrl(el) {
      var bg = el.css('background-image');
      bg = bg.replace('url(','').replace(')','').replace(/\"/gi, "");
      return bg;
  }
  
  /**/
  $(function () {
    for(var i = 0; i < settingTypes.length; i++) {
  		for(var j = 0; j < settings.length; j++) {
  			if(settingTypes[i].id == settings[j].dyrSettingTypeId) {
  				if(settingTypeCounts[settingTypes[i].id] == undefined) {
  					settingTypeCounts[settingTypes[i].id] = 1;
  				} else {
  					settingTypeCounts[settingTypes[i].id]++;
  				}
  			}
  		}
  	}
  	currentSettings = [];
  	for(var i = 0; i < settings.length; i++) {
  		if(settings[i].dyrSettingTypeId == currentSettingType) {
  			currentSettings.push(settings[i]);
  		}
  	}
  	changeMaterial('platinum', true);
    changeMaterialK('platinum');
  	//setButtonActions();
  	//updateRef();
    
      var ringdetail, currentSlickData= '';
  
  	// beforeChange / afterChange
  	// $('.slider-for').on('afterChange', function(event, slick, currentSlide, nextSlide){
  	// 	var CurrentSlideDom=$(slick.$slides.get(currentSlide));
  
  	// 	var NextSlideDom=$(slick.$slides.get(nextSlide));
   //        ringdetail = CurrentSlideDom.attr('data-ringref').split('#!#');
   //        currentSlickData['ringimage'] = CurrentSlideDom.attr('data-ringimage');
   //        currentSlickData['dimandimage'] = CurrentSlideDom.attr('data-dimandimage');
  	// 	console.log(ringdetail, ringdetail[0]);//
  	// });
      // $("#customring_design").on('click', '.btn-print',function(){
       $('.btn-print').click(function(){
         
          currentSlickData = document.querySelector('.slick-current .data-set').dataset;
          ringdetail = currentSlickData.ringref.split('#!#');
          $('.crd_popup_ref').html(currentSlickData.ringinfo);
          if(currentSlickData.materialk != "EITHER"){
             $('.crd_popup_metal').html(currentSlickData.materialk+" "+ringdetail[1]);
            $(".popup-form input[name='ring_metal']").val(currentSlickData.materialk+" "+ringdetail[1]);
          }else{
             $('.crd_popup_metal').html(ringdetail[1]);
             $(".popup-form input[name='ring_metal']").val(ringdetail[1]);
          }
          $('.crd_popup_style').html(ringdetail[2]);
          if(currentSlickData.diamondt != "EITHER"){
            $('.crd_popup_diamond').html(currentSlickData.diamondt+" "+ringdetail[3]);
            $(".popup-form input[name='diamond']").val(currentSlickData.diamondt+" "+ringdetail[3]);
          }else{
            $('.crd_popup_diamond').html(ringdetail[3]);
            $(".popup-form input[name='diamond']").val(ringdetail[3]);
          }
          $('.crd_popup_ring_src').css('background-image', 'url('+currentSlickData.ringimage+')');
          $('.crd_popup_diamond_src').attr('src', currentSlickData.dimandimage);
          $('.carat_weight').html(currentSlickData.dcr);
          $('.color').html(currentSlickData.dcol);
          $('.cut').html(currentSlickData.dcut);
          $('.clarity').html(currentSlickData.dcla);
          
          $(".popup-footer1").show();
          $(".popup-logo").show();
          $('.shareform').hide();
          $('.quoteform').hide();
          $('.share_form_btn').hide();
          $('.quote_form_btn').hide();
          $('.print_btn').show();
  
  		$('.popup-print').show();
  	});
      // $("#customring_design").on('click', '.btn-share', function(){
      $('.btn-share').click(function(){
          currentSlickData = document.querySelector('.slick-current .data-set').dataset;
          ringdetail = currentSlickData.ringref.split('#!#');
          $('.crd_popup_ref').html(currentSlickData.ringinfo);
       
          if(currentSlickData.materialk != "EITHER"){
             $('.crd_popup_metal').html(currentSlickData.materialk+" "+ringdetail[1]);
            $(".popup-form input[name='metal_type']").val(currentSlickData.materialk+" "+ringdetail[1]);
          }else{
             $('.crd_popup_metal').html(ringdetail[1]);
            $(".popup-form input[name='metal_type']").val(ringdetail[1]);
          }
          $('.crd_popup_style').html(ringdetail[2]);
          if(currentSlickData.diamondt != "EITHER"){
            $('.crd_popup_diamond').html(currentSlickData.diamondt+" "+ringdetail[3]);
            $(".popup-form input[name='diamond_type']").val(currentSlickData.diamondt+" "+ringdetail[3]);
          }else{
            $('.crd_popup_diamond').html(ringdetail[3]);
            $(".popup-form input[name='diamond_type']").val(ringdetail[3]);
          }
          $('.crd_popup_ring_src').css('background-image', 'url('+currentSlickData.ringimage+')');
          $('.crd_popup_diamond_src').attr('src', currentSlickData.dimandimage);
          $('.cw').hide();
          $('.co').hide();
          $('.cu').hide();
          $('.cla').hide();
          $(".popup-form input[name='carat_weight']").val(currentSlickData.dcr);
          $(".popup-form input[name='color']").val(currentSlickData.dcol);
          $(".popup-form input[name='cut']").val(currentSlickData.dcut);
          $(".popup-form input[name='clarity']").val(currentSlickData.dcla);
          $(".popup-form input[name='product_referance']").val(ringdetail[0]);
          
          $(".popup-form input[name='ring_style']").val(ringdetail[2]);
          
          $(".popup-form input[name='ring_image']").val(currentSlickData.ringimage);
          $(".popup-form input[name='diamond_image']").val(currentSlickData.dimandimage);
          $(".popup-form input[name='sender_name']").val($(".info_field input[name='fname']").val());
          $(".popup-form input[name='sender_email']").val($(".info_field input[name='email']").val());
          $(".popup-form input[name='comments']").val($(".info_field textarea[name='comments']").val());
          if($(".info_field input[name='fname']").val() != ""){
            $(".popup-form #s_name").html('<strong style="color: #8a2432;">Sender Name: </strong><span>'+$(".info_field input[name='fname']").val()+'</span>');
          }
          if($(".info_field input[name='email']").val() != ""){
            $(".popup-form #s_email").html('<strong style="color: #8a2432;">Sender Email: </strong><span>'+$(".info_field input[name='email']").val()+'</span>');
          }
          if($(".info_field textarea[name='comments']").val() != ""){
            $(".popup-form #comments").html('<strong style="color: #8a2432;">Comments: </strong><span>'+$(".info_field textarea[name='comments']").val()+'</span>');
          }
  
          $('.shareform').show();
          $('.quoteform').hide();
          $(".popup-footer1").hide();
          $(".popup-logo").hide();
          $('.print_btn').hide();
          $('.share_form_btn').show();
          $('.quote_form_btn').hide();
  
  		$('.popup-print').show();
  	});
      $('.btn-quote').click(function(){
        
          currentSlickData = document.querySelector('.slick-current .data-set').dataset;
          ringdetail = currentSlickData.ringref.split('#!#');
         
             $('.crd_popup_ref').html(currentSlickData.ringinfo);
          if(currentSlickData.materialk != "EITHER"){
             $('.crd_popup_metal').html(currentSlickData.materialk+" "+ringdetail[1]);
            $(".popup-form input[name='metal_type']").val(currentSlickData.materialk+" "+ringdetail[1]);
          }else{
             $('.crd_popup_metal').html(ringdetail[1]);
            $(".popup-form input[name='metal_type']").val(ringdetail[1]);
          }
          $('.crd_popup_style').html(ringdetail[2]);
          $(".popup-form input[name='ring_style']").val(ringdetail[2]);
          if(currentSlickData.diamondt != "EITHER"){
            $('.crd_popup_diamond').html(currentSlickData.diamondt+" "+ringdetail[3]);
            $(".popup-form input[name='diamond_type']").val(currentSlickData.diamondt+" "+ringdetail[3]);
          }else{
            $('.crd_popup_diamond').html(ringdetail[3]);
            $(".popup-form input[name='diamond_type']").val(ringdetail[3]);
          }
          $('.crd_popup_ring_src').css('background-image', 'url('+currentSlickData.ringimage+')');
          $('.crd_popup_diamond_src').attr('src', currentSlickData.dimandimage);
          $('.cw').hide();
          $('.co').hide();
          $('.cu').hide();
          $('.cla').hide();
          $(".popup-form input[name='carat_weight']").val(currentSlickData.dcr);
          $(".popup-form input[name='color']").val(currentSlickData.dcol);
          $(".popup-form input[name='cut']").val(currentSlickData.dcut);
          $(".popup-form input[name='clarity']").val(currentSlickData.dcla);
          $(".popup-form input[name='product_referance']").val(currentSlickData.ringinfo);
          $(".popup-form input[name='budget_price']").val($(".info_field input[name='budget']").val());
          $(".popup-form input[name='ring_image']").val(currentSlickData.ringimage);
          $(".popup-form input[name='diamond_image']").val(currentSlickData.dimandimage);
          $(".popup-form input[name='full_name']").val($(".info_field input[name='fname']").val());
          $(".popup-form input[name='email']").val($(".info_field input[name='email']").val());
          $(".popup-form input[name='phone']").val($(".info_field input[name='phone']").val());
          $(".popup-form input[name='address']").val($(".info_field input[name='address']").val());
          $(".popup-form input[name='city']").val($(".info_field input[name='city']").val());
          $(".popup-form input[name='state']").val($(".info_field input[name='state']").val());
          $(".popup-form input[name='zip']").val($(".info_field input[name='zip']").val());
          $(".popup-form input[name='comments']").val($(".info_field textarea[name='comments']").val());
          
          $('.shareform').hide();
          $('.quoteform').show();
          $(".popup-footer1").hide();
          $(".popup-logo").hide();
          $('.print_btn').hide();
          $('.share_form_btn').hide();
          $('.quote_form_btn').show();
  
  		$('.popup-print').show();
  	});
  	$('.close-btn').click(function(){
  		$('.popup-print').hide();
  	});
      // Set Metal Click & Animation
      // $("#customring_design").on('click', '.matel-main .textfirst', function(e){
      //     $('.matel-main .textfirst').html('Select Metal');
      //     $('.mm-dropdown.matel-main > ul').toggleClass('active');
      // });
  
      // Set Style Click & Animation
      // $("#customring_design").on('click', '.style-main .textfirst', function(e){
      //     $('.style-main .textfirst').html('Select Style');
      //     $('.mm-dropdown.style-main > ul').toggleClass('active');
      // });
  
      // Set Diamond Click & Animation
      // $("#customring_design").on('click', '.diamond-main .textfirst', function(e){
      //     $('.diamond-main .textfirst').html('Select Diamond Shape');
      //     $('.mm-dropdown.diamond-main > ul').toggleClass('active');
      // });
  });
});